import { render } from "./ServiceAdditional.vue?vue&type=template&id=fb15b886"
import script from "./ServiceAdditional.vue?vue&type=script&lang=js"
export * from "./ServiceAdditional.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "fb15b886"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fb15b886', script)) {
    api.reload('fb15b886', script)
  }
  
  module.hot.accept("./ServiceAdditional.vue?vue&type=template&id=fb15b886", () => {
    api.rerender('fb15b886', render)
  })

}

script.__file = "src/views/services/modules/ServiceAdditional.vue"

export default script